// Wraps fetch() so every /api/* request carries the Frontegg-issued JWT as a
// Bearer token. The backend (FronteggAuthSubscriber) rejects unauthenticated
// /api/* calls with 401 — never inline a raw fetch() against /api/* paths.
export async function authFetch(url, options = {}) {
    const store = window.klarnachrichten?.login?.app?.store;
    const auth = store?.getState()?.auth;
    const token = auth?.user?.accessToken;
    const headers = { ...(options.headers || {}) };
    if (token) {
        headers['Authorization'] = `Bearer ${token}`;
    }
    return fetch(url, { ...options, headers });
}
